'use client';

import { LargePrimaryButton } from '../../../components/core/buttons';
import { SemiboldBody } from '../../../components/core/typography';
import FormInput from '../../../components/formBuilder/formBuilder';
import VtEditInput from '../../../components/vt/base/vteditinput';
import { Form, FormInstance, Spin } from 'antd';
import React, { useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { forgotPassword } from '../../../services/api';

interface OldLoginProps {
	form: FormInstance;
	setStep: any;
	userLogin: (values: { email: string; password: string }) => void;
	email: string;
	setIsNewUser: any;
	setIsForgotPassword: any;
	loading?: boolean;
}

const OldUserLogin: React.FC<OldLoginProps> = ({
	form,
	setStep,
	userLogin,
	email,
	setIsNewUser,
	setIsForgotPassword,
	loading,
}) => {
	const handleEditClick = () => {
		setStep(1);
	};
	const [showLoader, setShowLoader] = useState(false);
	const handleLoginClick = async () => {
		try {
			await form.validateFields();
			const values = { ...form.getFieldsValue(), email };
			console.log('Form Values before login:', values);
			await userLogin(values);
		} catch (errorInfo) {
			console.log('Validation Failed:', errorInfo);
		}
	};

	const handleForgotPassword = async () => {
		try {
			const res = await forgotPassword({ email: email });
			setIsForgotPassword(true);
			setIsNewUser(true);
		} catch (errorInfo) {
			console.log('Validation Failed:', errorInfo);
		}
	};
	return (
		<div className="w-full">
			<Form layout='vertical' initialValues={{ remember: true }} form={form}>
				<div className='w-full max-w-[360px]'>
					<div className='mb-6 lg:mb-[24px]'>
						<VtEditInput handleClick={handleEditClick} content={email} />
					</div>

					<FormInput
						name='password'
						autoFocus
						type='password'
						label='Enter password'
						width='100%'
						placeholder='Enter here'
						onPressEnter={handleLoginClick}
						rules={[
							{
								required: true,
								message: 'Please enter your password',
							},
						]}
					/>
				</div>

				<div className='w-full mt-8 lg:mt-[40px] mb-5 lg:mb-[20px]'>
					<LargePrimaryButton
						text='Log in'
						handleClick={handleLoginClick}
						style={{ width: '100%' }}
						loading={loading}
					/>
				</div>
				<div className='w-full flex items-center justify-center cursor-pointer' onClick={handleForgotPassword}>
					<SemiboldBody text={'Forgot password ?'} color='#6941C6' />
				</div>
			</Form>
		</div>
	);
};

export default OldUserLogin;
